import { Box, Button, Grid, Modal, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';

const PasswordModal = ({ open, onClose, onSubmit }) => {
  const [password, setPassword] = useState('');

  const handleConfirm = () => {
    onSubmit(password);
    setPassword('');
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'white',
        padding: 4,
        borderRadius: 2,
        width: '90%',
        maxWidth: 400,
      }}>
        <Grid display={'flex'} alignItems={'center'} gap={'8px'} mb={'16px'}>
          <img src='./assets/images/warning-alert.svg' alt='' style={{ width: '24px', height: "24px" }} />
          <Typography variant='subtitle1'>این فرم با رمز عبور محافظت شده است . لطفا برای پر کردن فرم ابتدا رمز عبور را وارد کنید</Typography>
        </Grid>
        <form>
          <Grid container direction="column" spacing={4}>
            <Grid item>
              <input
                style={{
                  width: '100%',
                  height: '24px',
                  padding: '20px 12px',
                  direction: 'ltr'
                }}
                placeholder="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                type="password"
              />
            </Grid>
            <Grid item>
              <Button type='submit' fullWidth variant="contained" onClick={handleConfirm} sx={{ p: '8px', fontSize: "14px", fontWeight: '700' }}>
                تایید
              </Button>
            </Grid>
          </Grid>
        </form>

      </Box>
    </Modal>
  );
};

export default PasswordModal;
